<template>
  <div id="conteneurArchive">
    <Toast />
    <HeaderHome :user="this.$store.state.user.prenom" />

    <main class="page-main">
      <div class="page-header">
        <div class="page-header-left">
          <h1 class="page-title">Élèves archivés</h1>
          <p class="page-subtitle">Archive chez {{ this.$store.state.user.agence.nom }}</p>
        </div>
      </div>

      <div class="table-wrap">
        <DataTable
          :value="eleveArchived"
          responsiveLayout="scroll"
          dataKey="id"
        >
          <Column field="nom" header="Nom" :sortable="true" style="min-width: 12rem" />
          <Column field="prenom" header="Prénom" :sortable="true" style="min-width: 12rem" />
          <Column field="telephone" header="Téléphone" :sortable="true" style="min-width: 12rem" />
          <Column field="email" header="Mail" :sortable="true" style="min-width: 12rem" />
          <Column header="Désarchiver" :exportable="false" style="min-width: 8rem">
            <template #body="slotProps">
              <Checkbox
                :binary="true"
                :modelValue="true"
                @click="DesarchiveEleve(slotProps.data.id)"
              />
            </template>
          </Column>
        </DataTable>
        <Paginator
          :rows="10"
          :totalRecords="eleveArchivedCount"
          @page="onPaginate"
          class="table-paginator"
        />
      </div>
    </main>
  </div>
</template>

<script>
import { useToast } from "primevue/usetoast";
import HeaderHome from "@/components/home/HeaderHome.vue";

export default {
  name: "ListeArchive",

  components: {
    HeaderHome,
  },

  data() {
    return {
      toast: useToast(),
      eleveArchived: [],
      eleveArchivedCount: 0,
    };
  },

  mounted() {
    this.getElevesArchives(0);
  },

  methods: {
    getElevesArchives(offset) {
      window.api
        .get("/eleves/agence/" + this.$store.state.user.agence.id + "/archives/" + offset, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.eleveArchived = response.data.eleves;
          this.eleveArchivedCount = response.data.total;
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },

    onPaginate(e) {
      this.getElevesArchives(e.first);
    },

    async DesarchiveEleve(id) {
      try {
        if (confirm("Voulez vous vraiment désarchiver cet élève ?")) {
          window.api
            .patch(
              "utilisateur/" + id,
              { active: true },
              { headers: { Authorization: "Bearer " + this.$store.state.token } }
            )
            .then(() => {
              this.toast.add({
                severity: "success",
                summary: "Élève désarchivé",
                detail: "L'élève a été désarchivé avec succès",
                life: 3000,
              });
              this.getElevesArchives(0);
            });
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped>
#conteneurArchive {
  background: #f4f6f9;
  min-height: 100vh;
}

/* ===================== PAGE MAIN ===================== */
.page-main {
  width: 90%;
  margin: 0 auto;
  padding: 40px 40px;
  text-align: left;
}

.page-header {
  margin-bottom: 32px;
}

.page-title {
  font-size: 30px;
  font-weight: bold;
  color: #1a1f2e;
  letter-spacing: -0.5px;
  margin-bottom: 4px;
}

.page-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

/* ===================== TABLE ===================== */
.table-wrap {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  overflow-x: auto;
}

.table-paginator {
  border-top: 1px solid #e2e8f0;
}
</style>
